import { RadioGroup as ChakraRadioGroup } from "@chakra-ui/react";
import type { ComponentProps } from "react";
import type { RadioGroupSharedProps } from "./RadioGroup.props";

export default function RadioGroup({
  onChange,
  onValueChange,
  value,
  defaultValue,
  ...props
}: RadioGroupProps): JSX.Element {
  const shouldCoerceToNumber =
    typeof value === "number" || typeof defaultValue === "number";

  return (
    <ChakraRadioGroup.Root
      value={value !== undefined ? String(value) : undefined}
      defaultValue={
        defaultValue !== undefined ? String(defaultValue) : undefined
      }
      onValueChange={(details: { value: string }) => {
        onChange?.(
          shouldCoerceToNumber ? Number(details.value) : details.value
        );
        onValueChange?.(details);
      }}
      {...props}
    />
  );
}

type ChakraRadioGroupRootProps = ComponentProps<typeof ChakraRadioGroup.Root>;

export type RadioGroupProps = RadioGroupSharedProps &
  Omit<
    ChakraRadioGroupRootProps,
    "value" | "defaultValue" | "onValueChange" | "children"
  > & {
    value?: string | number;
    defaultValue?: string | number;
    /**
     * Chakra v1/v2 compatibility
     */
    onChange?: (value: string | number) => void;
    /**
     * Chakra v3
     */
    onValueChange?: (details: { value: string }) => void;
  };
